const CatalogModelOptionMixin = {
  methods: {
    getCatalogModelOptions(model, params = {}) {
      const url = route("public.api.models.options.index", { model: model.id });

      return axios.get(url, { params: params });
    },
    getCatalogModelOptionsCategorized(model, params = {}) {
      const url = route("public.api.models.options.categorized", {
        model: model.id,
      });

      return axios.get(url, { params: params });
    },
  },
};

export default CatalogModelOptionMixin;
